// extracted by mini-css-extract-plugin
export default {"wrapper":"FloorSlider_wrapper__Bshsz","arrow":"FloorSlider_arrow__s+8+K"};